import { NumberInput, Stack } from '@mantine/core'
import React, { useCallback } from 'react'

import { Amount } from '@/components/CurrencyInput'
import { useGovernanceContext } from '@/contexts/GovernanceContext'
import { ProcessedBalance } from '@/utils/utils'

interface VoteActionProps {
  totalVotes: number
  votes: Amount
  setVotes: (value: Amount) => void
  isBreakpoint?: boolean
  remainingVoteBalance: ProcessedBalance
}

const VoteInput: React.FC<VoteActionProps> = ({
  isBreakpoint,
  totalVotes,
  votes,
  setVotes,
  remainingVoteBalance,
}) => {
  const { vote } = useGovernanceContext()

  const handleVoteChange = useCallback(
    (value: number | string) => {
      if (
        totalVotes + Number(value) - Number(votes.value) >
        Number(remainingVoteBalance.fullValue)
      ) {
        setVotes({ value: `${value}`, touched: true, error: 'Total votes exceed available votes' })
      } else {
        setVotes({ value: `${value}`, touched: true, error: '' })
      }
    },
    [totalVotes, vote]
  )

  return (
    <Stack
      onClick={e => e.stopPropagation()}
      style={{
        flexDirection: 'row',
        gap: '20px',
        alignItems: 'center',
        width: isBreakpoint ? '100%' : '',
      }}
    >
      <NumberInput
        value={votes.value}
        onChange={handleVoteChange}
        placeholder="0"
        styles={{
          root: {
            width: isBreakpoint ? '100%' : '',
          },
          input: {
            borderBottom: '1px solid',
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderRadius: 0,
            height: 40,
          },
        }}
        min={0}
        max={Number(remainingVoteBalance.value)}
        rightSection={
          <a
            style={{ cursor: 'pointer' }}
            onClick={() => handleVoteChange(Number(remainingVoteBalance.fullValue))}
          >
            Max
          </a>
        }
        required
        error={votes.error}
      />
    </Stack>
  )
}

export default VoteInput
